import { useEffect, useState } from "react";
import CarrinhoItem from "./carrinhoItem/CarrinhoItem";

export default function CarrinhoLista({
  produtos,
  setProdutos,
  usuario,
  limitecrdt,
}) {
  const [loading, setLoading] =
    useState(true);
//console.log("produto",produtos)
  useEffect(() => {
    async function atualizarProdutos() {

      if (produtos.length === 0) {
        setLoading(false);
        return;
      }

      try {

        const body = {
          coditens: produtos.map((p) =>
            Number(p.codProduto)
          ),
          codcliente: Number(
            usuario.codcliente
          ),
        };

        const res = await fetch(
          "https://app.eliandroalimentos.com.br/api/produtos/listarprodutoscarrinho",
          {
            method: "POST",
            headers: {
              "Content-Type":
                "application/json",
            },
            body: JSON.stringify(body),
          }
        );

        const dados =
          await res.json();

        const atualizado =
          produtos.map((itemLocal) => {

            const banco =
              dados.find(
                (p) =>
                  String(p.CodItem) ===
                  String(itemLocal.codProduto)
              );

            if (!banco)
              return itemLocal;

            return {
              ...itemLocal,

              descricao:
                banco.Descricao,

              foto:
                banco.foto,

              saldototal:
                Number(
                  banco.saldototal
                ),

              pesob:
                banco.pesob,

              pesol:
                banco.pesol,

              valorunitario:
                banco.valorunitario,

              precovenda:
                banco.precovenda,

              correspondencias:
                banco.correspondencias,
                corrigepreco:
                banco.corrigepreco
            };
          });

        setProdutos(
          atualizado
        );

      } catch (erro) {
        console.error(
          erro
        );
      }

      setLoading(false);

    }

    atualizarProdutos();

  }, []);

 if (loading) {
  return (
    <div className="lista-carrinho-loading">
      Atualizando carrinho...
    </div>
  );
}

  return (
    <section className="lista-carrinho">

      <div className="cabecalho-carrinho">

      </div>

      {produtos.map(
        (produto) => (

          <CarrinhoItem
            key={
              produto.codProduto
            }
            produto={
              produto
            }
            produtos={
              produtos
            }
            setProdutos={
              setProdutos
            }
             limitecrdt={limitecrdt}
          />

        )
      )}

    </section>
  );
}